module.exports = __webpack_public_path__ + "static/img/10.0a0b3ed3.png";